import { LabelInput } from '../label/labelInput';
import { EntityLinkInput } from '../entityLink/entityLinkInput';

export class IssueInput {
  id: string;
  typeCode: string;
  title: string;
  description: string;
  //subject: LinkableInput;
  externalId: string;
  dueDateTime: string;
  labels: LabelInput[];
  entityLinks: EntityLinkInput[];
  locationId?: string | null;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.typeCode = payload.typeCode;
      this.title = payload.title;
      this.description = payload.description;
      //this.subject = payload.subject ? new LinkableInput(payload.subject) : undefined;
      this.externalId = payload.externalId;
      this.dueDateTime = payload.dueDateTime;
      this.labels = payload.labels || [];
      this.entityLinks = payload.entityLinks || [];
      this.locationId = payload.locationId || null;
    }
  }

}
